<template>
  <section class="product-section-reservation">
    <product-section-sub-info class="px-5" :arrival-times="arrivalTimes" />
    <p v-if="isSoldOut" class="py-4 text-center text-gray-80 text-sm">{{ $t('branch_detail.bottom_bar.sold_out') }}</p>
    <product-time-slots
      v-else-if="selectedDateSlots.length"
      :slots="selectedDateSlots"
      class="-ml-1 lg:mb-5"
      arrow-btn-class="w-auto"
      arrow-icon-class="size-10 p-2"
      arrow-icon-right-class="mr-3"
      arrow-icon-left-class="ml-3"
      time-slots-container-class="px-5"
      :selected-slot="slotInfo?.slot"
      @slot-click="handleSlotClick"
    />
    <p v-else class="py-4 text-center text-gray-80 text-sm">{{ $t('reservation.date_picker.no_time_slot') }}</p>
  </section>
</template>

<script setup lang="ts">
import ProductTimeSlots from '@/components/product/product-time-slots.vue'
import ProductSectionSubInfo from '@/components/product/product-detail/product-section-sub-info.vue'

import type { SlotInfo } from '@/types/product'
import type { BranchArrivalTimeInfo } from '@/types/api'

interface Props {
  arrivalTimes?: Nullable<BranchArrivalTimeInfo>
}

const props = defineProps<Props>()

const { date, slotInfo, isSoldOut } = useBranchDetailContext()

const selectedDateSlots = computed(() => {
  if (!date.value || !props.arrivalTimes?.slots) {
    return []
  }

  return props.arrivalTimes.slots.filter(slotInfo => slotInfo.slot?.split(' ')[0] === date.value)
})

function handleSlotClick(slot: SlotInfo) {
  slotInfo.value = slot
}
</script>

<style lang="scss" scoped>
.product-section-reservation {
  :deep(.list-arrow-left) {
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 15%, #fff 81.25%);
  }
  :deep(.list-arrow-right) {
    background: linear-gradient(270deg, #fff 15%, rgba(255, 255, 255, 0) 81.25%);
  }
}
</style>
